import {Link, useParams} from 'react-router-dom';

import {QuestionMatchingEvaluationResponse} from '~/features/AiSupport/QuestionMatchingEvaluationResponse';

export const QuestionMatchingEvaluationResponseScene = () => {
  const {questionSampleSetId, questionMatchingEvaluationId} = useParams();
  return (
    <div className="bg-background min-h-screen">
      <div className="text-sm breadcrumbs p-4">
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/ai-support/question-sample-sets">
              Question Sample Sets
            </Link>
          </li>
          <li>
            <Link
              to={`/ai-support/question-sample-sets/${questionSampleSetId}`}>
              {questionSampleSetId}
            </Link>
          </li>
          <li>Evaluation</li>
        </ul>
      </div>
      <QuestionMatchingEvaluationResponse
        questionSampleSetId={questionSampleSetId ?? ''}
        questionMatchingEvaluationId={questionMatchingEvaluationId ?? ''}
      />
    </div>
  );
};
